import React from "react";

/**
 * chat-experience 06c (D-40) — the inside of one prompt-library row, shared by the starters list and
 * the `+` → Prompts view so the two surfaces draw the same thing. The glyph and the count are
 * decoration (`aria-hidden`); the label is the tenant's own string, rendered verbatim.
 */
export default function PromptRowContent({ row }) {
	const isCollection = row.type === "collection";
	const icon = isCollection ? (row.open ? "▾" : "▸") : row.depth === 0 ? "›" : "";
	return (
		<>
			<span className="prompt-row-icon" aria-hidden="true">{icon}</span>
			<span className="prompt-row-label">{isCollection ? row.name : row.prompt.label}</span>
			{isCollection && <span className="prompt-row-count" aria-hidden="true">{row.count}</span>}
		</>
	);
}
